/*jslint ignore:start*/

export function slideUp(a, b = 500) {
  (a.style.transitionProperty = "height, margin, padding"),
    (a.style.transitionDuration = b + "ms"),
    (a.style.boxSizing = "border-box"),
    (a.style.height = a.offsetHeight + "px"),
    a.offsetHeight,
    (a.style.overflow = "hidden"),
    (a.style.height = 0),
    (a.style.paddingTop = 0),
    (a.style.paddingBottom = 0),
    (a.style.marginTop = 0),
    (a.style.marginBottom = 0),
    window.setTimeout(() => {
      (a.style.display = "none"),
        a.style.removeProperty("height"),
        a.style.removeProperty("padding-top"),
        a.style.removeProperty("padding-bottom"),
        a.style.removeProperty("margin-top"),
        a.style.removeProperty("margin-bottom"),
        a.style.removeProperty("overflow"),
        a.style.removeProperty("transition-duration"),
        a.style.removeProperty("transition-property");
    }, b);
}

export function slideDown(a, b = 500) {
  a.style.removeProperty("display");
  let c = window.getComputedStyle(a).display;
  "none" === c && (c = "flex"), (a.style.display = c);
  let d = a.offsetHeight;
  (a.style.overflow = "hidden"),
    (a.style.height = 0),
    (a.style.paddingTop = 0),
    (a.style.paddingBottom = 0),
    (a.style.marginTop = 0),
    (a.style.marginBottom = 0),
    a.offsetHeight,
    (a.style.boxSizing = "border-box"),
    (a.style.transitionProperty = "height, margin, padding"),
    (a.style.transitionDuration = b + "ms"),
    (a.style.height = d + "px"),
    a.style.removeProperty("padding-top"),
    a.style.removeProperty("padding-bottom"),
    a.style.removeProperty("margin-top"),
    a.style.removeProperty("margin-bottom"),
    window.setTimeout(() => {
      a.style.removeProperty("height"),
        a.style.removeProperty("overflow"),
        a.style.removeProperty("transition-duration"),
        a.style.removeProperty("transition-property");
    }, b);
}

export function slideToggle(a, b = 500) {
  "none" === window.getComputedStyle(a).display
    ? slideDown(a, b)
    : slideUp(a, b);
}

export function toggleAria(el, att, value) {
  // If setting a specific value do it and return
  if (value) {
    el.setAttribute(att, value);
    return;
  }

  if (el.getAttribute(att) == "true") {
    el.setAttribute(att, false);
  } else {
    el.setAttribute(att, true);
  }
}

// https://hiddedevries.nl/en/blog/2017-01-29-using-javascript-to-trap-focus-in-an-element
export function trapFocus(element, addFirstEl, elToFocus) {
  let focusableEls = Array.from(
    element.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="submit"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    )
  );

  if (addFirstEl) {
    if (addFirstEl.constructor === Array)
      focusableEls = addFirstEl.concat(focusableEls);
    else focusableEls.unshift(addFirstEl);
  }

  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];
  const KEYCODE_TAB = 9;

  if (elToFocus)
    setTimeout(() => {
      elToFocus.focus();
    }, 10);
  else
    setTimeout(() => {
      firstFocusableEl.focus();
    }, 10);

  element.addEventListener("keydown", function (e) {
    var isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      /* shift + tab */ 
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } /* tab */ else {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  });
}

/*jslint ignore:end*/
